<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" fill="white" viewBox="0 0 512 512">
  <path d="M64 64h160v384h-160zM288 64h160v384h-160z"></path>
  </svg>
</template>
